import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/speakSearch.css';
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SurnameGroup = () => {
    // --- State ---
    const [surnameGroups, setSurnameGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // --- Context ---
    const { appId, language, userId } = useAppId();
    const lang = language || 'en';

    const location = useLocation();
    const navigate = useNavigate();


    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "My Surname Groups",
            filterGroups: "Search by group name...",
            loadingData: "Loading Surname Groups...",
            noData: "No surname groups found.",
            groupName: "Group Name",
            voterCount: "Total Voters :",
            groupId: "Group ID",
            totalGroups: "Total Groups",
            totalVoters: "Total Voters",
            edit: "Edit",
            delete: "Delete",
            selectAll: "Select All",
            removeAll: "Remove All",
            updateGroup: "Update Group",
            groupNameLabel: "Group Name",
            updateGroupName: "Update Group Name",
            cancel: "Cancel",
            update: "Update",
            insertGroup: "Insert Group",
            searchSurname: "Search surname...",
            searching: "Searching...",
            insert: "Insert",
            selectedSurnames: "Selected",
            noSurnamesFound: "No surnames found",
            next: "Next",
            selectVoters: "Select Voters",
            noVotersFound: "No voters found",
            loadingVoters: "Loading voters...",
            // Validation messages
            selectAtLeastOneSurname: "Please select at least one surname.",
            enterGroupName: "Please enter a group name.",
            selectAtLeastOneVoter: "Please select at least one voter.",
            groupNameRequired: "Group name is required.",
            surnameRequired: "Please select at least one surname before proceeding.",
            voterRequired: "Please select at least one voter to insert.",
            groupInsertSuccess: "Group inserted successfully!",
            groupInsertFailed: "Failed to insert group.",
            groupInsertError: "An error occurred while inserting group."
        },
        hi: {
            pageTitle: "मेरे उपनाम समूह",
            filterGroups: "समूह नाम से खोजें...",
            loadingData: "उपनाम समूह लोड हो रहे हैं...",
            noData: "कोई उपनाम समूह नहीं मिला।",
            groupName: "समूह का नाम",
            voterCount: "कुल मतदाता :",
            groupId: "समूह आईडी",
            totalGroups: "कुल समूह",
            totalVoters: "कुल मतदाता",
            edit: "एडिट",
            delete: "डिलीट",
            selectAll: "सभी का चयन करें",
            removeAll: "सभी हटाएं",
            updateGroup: "ग्रुप अपडेट करें",
            groupNameLabel: "समूह का नाम",
            updateGroupName: "समूह का नाम अपडेट करें",
            cancel: "रद्द करें",
            update: "अपडेट करें",
            insertGroup: "समूह डालें",
            searchSurname: "उपनाम खोजें...",
            searching: "खोज रहे हैं...",
            insert: "डालें",
            selectedSurnames: "चयनित",
            noSurnamesFound: "कोई उपनाम नहीं मिला",
            next: "अगला",
            selectVoters: "मतदाता चुनें",
            noVotersFound: "कोई मतदाता नहीं मिला",
            loadingVoters: "मतदाता लोड हो रहे हैं...",
            // Validation messages
            selectAtLeastOneSurname: "कृपया कम से कम एक उपनाम चुनें।",
            enterGroupName: "कृपया एक समूह नाम दर्ज करें।",
            selectAtLeastOneVoter: "कृपया कम से कम एक मतदाता चुनें।",
            groupNameRequired: "समूह नाम आवश्यक है।",
            surnameRequired: "आगे बढ़ने से पहले कृपया कम से कम एक उपनाम चुनें।",
            voterRequired: "डालने के लिए कृपया कम से कम एक मतदाता चुनें।",
            groupInsertSuccess: "समूह सफलतापूर्वक डाला गया!",
            groupInsertFailed: "समूह डालने में विफल।",
            groupInsertError: "समूह डालते समय एक त्रुटि हुई।"
        },
        gu: {
            pageTitle: "મારા ઉપનામ જૂથો",
            filterGroups: "જૂથ નામથી શોધો...",
            loadingData: "ઉપનામ જૂથો લોડ થઈ રહ્યા છે...",
            noData: "કોઈ ઉપનામ જૂથ મળ્યા નથી.",
            groupName: "જૂથ નામ",
            voterCount: "કુલ મતદાર :",
            groupId: "જૂથ ID",
            totalGroups: "કુલ જૂથો",
            totalVoters: "કુલ મતદારો",
            edit: "એડિટ",
            delete: "ડિલીટ",
            selectAll: "બધા પસંદ કરો",
            removeAll: "બધા કાઢો",
            updateGroup: "ગૃપ અપડેટ કરો",
            groupNameLabel: "જૂથ નામ",
            updateGroupName: "જૂથ નામ અપડેટ કરો",
            cancel: "રદ કરો",
            update: "અપડેટ કરો",
            insertGroup: "જૂથ દાખલ કરો",
            searchSurname: "ઉપનામ શોધો...",
            searching: "શોધી રહ્યા છે...",
            insert: "દાખલ કરો",
            selectedSurnames: "પસંદ કરેલ",
            noSurnamesFound: "કોઈ ઉપનામ મળ્યા નથી",
            next: "આગળ",
            selectVoters: "મતદારો પસંદ કરો",
            noVotersFound: "કોઈ મતદાર મળ્યા નથી",
            loadingVoters: "મતદારો લોડ થઈ રહ્યા છે...",
            // Validation messages
            selectAtLeastOneSurname: "કૃપા કરીને ઓછામાં ઓછું એક ઉપનામ પસંદ કરો.",
            enterGroupName: "કૃપા કરીને જૂથ નામ દાખલ કરો.",
            selectAtLeastOneVoter: "કૃપા કરીને ઓછામાં ઓછો એક મતદાર પસંદ કરો.",
            groupNameRequired: "જૂથ નામ જરૂરી છે.",
            surnameRequired: "આગળ વધતા પહેલા કૃપા કરીને ઓછામાં ઓછું એક ઉપનામ પસંદ કરો.",
            voterRequired: "દાખલ કરવા માટે કૃપા કરીને ઓછામાં ઓછો એક મતદાર પસંદ કરો.",
            groupInsertSuccess: "જૂથ સફળતાપૂર્વક દાખલ થયું!",
            groupInsertFailed: "જૂથ દાખલ કરવામાં નિષ્ફળ.",
            groupInsertError: "જૂથ દાખલ કરતી વખતે એક ભૂલ આવી."
        }
    };

    const txt = t[lang] || t.gu;


    const passedUserId = location.state?.userId;
    const targetUserId = passedUserId || userId;

    // --- Fetch Surname Groups API ---
    const fetchSurnameGroups = async () => {
        if (!appId || !userId) return;

        setLoading(true);
        setSearchTerm("");
        setCurrentPage(1);

        try {
            const response = await axios.post(`${BASE_URL}/api/dis_my_surname_group`, {
                app_id: appId,
                user_id: targetUserId
            });

            if (response.data.success && Array.isArray(response.data.data.result)) {
                setSurnameGroups(response.data.data.result);
            } else {
                setSurnameGroups([]);
            }
        } catch (error) {
            console.error("Error fetching surname groups:", error);
            setSurnameGroups([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSurnameGroups();
    }, [appId, userId]);

    // --- Filter Logic ---
    const filteredGroups = surnameGroups.filter((group) =>
        group.surname && group.surname.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // --- Pagination Logic ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredGroups.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredGroups.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Calculate total voters
    const totalVoters = surnameGroups.reduce((sum, group) => sum + (group.voter_count || 0), 0);
    const totalGroups = surnameGroups.length;

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleDeleteGroup = async (groupId) => {
        if (!window.confirm("Are you sure you want to delete this group?")) return;

        try {
            const response = await axios.post(`${BASE_URL}/api/dlt_surname_group`, {
                app_id: appId,
                user_id: targetUserId,
                group_id: groupId,
                delete_by: userId
            });

            if (response.data.success) {
                alert("Group deleted successfully!");
                fetchSurnameGroups();
            } else {
                alert("Failed to delete group.");
            }
        } catch (error) {
            console.error("Error deleting group:", error);
            alert("An error occurred while deleting.");
        }
    };

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isUpdateNameModalOpen, setIsUpdateNameModalOpen] = useState(false);
    const [editMembers, setEditMembers] = useState([]);
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [currentGroupName, setCurrentGroupName] = useState("");
    const [newGroupName, setNewGroupName] = useState("");
    const [updating, setUpdating] = useState(false);

    // Insert Group State
    const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
    const [isSelectVotersModalOpen, setIsSelectVotersModalOpen] = useState(false);
    const [insertSearchTerm, setInsertSearchTerm] = useState("");
    const [insertSurnames, setInsertSurnames] = useState([]);
    const [insertSelectedSurnames, setInsertSelectedSurnames] = useState([]);
    const [insertGroupName, setInsertGroupName] = useState("");
    const [insertSearching, setInsertSearching] = useState(false);
    const [inserting, setInserting] = useState(false);
    const [groupNameError, setGroupNameError] = useState("");

    // Voters from surname_wise_search
    const [surnameWiseVoters, setSurnameWiseVoters] = useState([]);
    const [loadingVoters, setLoadingVoters] = useState(false);

    // Helper function to add trailing comma
    const addTrailingComma = (str) => {
        if (!str) return '';
        return str.endsWith(',') ? str : str + ',';
    };

    // Edit button function - First popup (select voters)
    const handleEditGroup = async (groupId, groupName) => {
        setCurrentGroupId(groupId);
        setCurrentGroupName(groupName);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_surname_group_edit`, {
                app_id: appId,
                user_id: targetUserId,
                group_id: groupId
            });
            if (response.data.success) {
                const members = response.data.data.result || [];
                const membersWithCheck = members.map(member => ({
                    ...member,
                    checked: member.is_member === 1
                }));
                setEditMembers(membersWithCheck);
                setIsEditModalOpen(true);
            }
        } catch (error) {
            console.error("Error fetching edit data:", error);
        }
    };

    // Handle checkbox change for edit modal
    const handleCheckboxChange = (index) => {
        const updatedMembers = [...editMembers];
        updatedMembers[index].checked = !updatedMembers[index].checked;
        setEditMembers(updatedMembers);
    };

    // Handle row click to toggle checkbox
    const handleRowClick = (index) => {
        const updatedMembers = [...editMembers];
        updatedMembers[index].checked = !updatedMembers[index].checked;
        setEditMembers(updatedMembers);
    };

    // Select All for edit modal
    const handleSelectAll = () => {
        const updatedMembers = editMembers.map(member => ({
            ...member,
            checked: true
        }));
        setEditMembers(updatedMembers);
    };

    // Remove All for edit modal
    const handleRemoveAll = () => {
        const updatedMembers = editMembers.map(member => ({
            ...member,
            checked: false
        }));
        setEditMembers(updatedMembers);
    };

    // After selecting voters, open second popup for group name update
    const handleProceedToUpdateName = () => {
        setNewGroupName(currentGroupName);
        setIsEditModalOpen(false);
        setIsUpdateNameModalOpen(true);
    };

    // Final Update with API - with distinct surnames and trailing comma
    const handleFinalUpdate = async () => {
        const selectedMembers = editMembers.filter(member => member.checked);

        const distinctSurnames = [...new Set(selectedMembers.map(member => member.eng_surname || '').filter(s => s))];

        let idcardList = selectedMembers.map(member => member.idcard_no).join(',');
        idcardList = addTrailingComma(idcardList);

        let surnameList = distinctSurnames.join(',');
        surnameList = addTrailingComma(surnameList);

        setUpdating(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/upd_surname_group`, {
                app_id: appId,
                user_id: targetUserId,
                group_id: currentGroupId,
                group_name: newGroupName,
                seed_surname: newGroupName,
                surname_list: surnameList,
                idcard_list: idcardList,
                modify_by: userId
            });

            if (response.data.success) {
                alert("Group updated successfully!");
                setIsUpdateNameModalOpen(false);
                fetchSurnameGroups();
            } else {
                alert("Failed to update group.");
            }
        } catch (error) {
            console.error("Error updating group:", error);
            alert("An error occurred while updating.");
        } finally {
            setUpdating(false);
        }
    };

    // Insert Group Functions
    const handleOpenInsertModal = () => {
        setIsInsertModalOpen(true);
        setInsertSearchTerm("");
        setInsertSurnames([]);
        setInsertSelectedSurnames([]);
        setInsertGroupName("");
        setGroupNameError("");
    };

    const handleInsertSearch = async () => {
        if (!insertSearchTerm.trim()) return;

        setInsertSearching(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/get_all_match_surname_list`, {
                app_id: appId,
                search_input: insertSearchTerm
            });

            if (response.data.success && response.data.data.result) {
                const surnamesWithCheck = response.data.data.result.map(surname => ({
                    eng_surname: surname.eng_surname,
                    checked: false
                }));
                setInsertSurnames(surnamesWithCheck);
            } else {
                setInsertSurnames([]);
            }
        } catch (error) {
            console.error("Error searching surnames:", error);
            setInsertSurnames([]);
        } finally {
            setInsertSearching(false);
        }
    };

    // Handle Enter key press for search
    const handleInsertSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleInsertSearch();
        }
    };

    // Handle checkbox change in insert modal
    const handleInsertCheckboxChange = (index) => {
        const updatedSurnames = [...insertSurnames];
        updatedSurnames[index].checked = !updatedSurnames[index].checked;
        setInsertSurnames(updatedSurnames);

        const selected = updatedSurnames.filter(s => s.checked).map(s => s.eng_surname);
        setInsertSelectedSurnames(selected);
    };

    // Handle row click in insert modal
    const handleInsertRowClick = (index) => {
        const updatedSurnames = [...insertSurnames];
        updatedSurnames[index].checked = !updatedSurnames[index].checked;
        setInsertSurnames(updatedSurnames);

        const selected = updatedSurnames.filter(s => s.checked).map(s => s.eng_surname);
        setInsertSelectedSurnames(selected);
    };

    // Select all in insert modal
    const handleInsertSelectAll = () => {
        const updatedSurnames = insertSurnames.map(surname => ({
            ...surname,
            checked: true
        }));
        setInsertSurnames(updatedSurnames);
        const selected = updatedSurnames.filter(s => s.checked).map(s => s.eng_surname);
        setInsertSelectedSurnames(selected);
    };

    // Remove all in insert modal
    const handleInsertRemoveAll = () => {
        const updatedSurnames = insertSurnames.map(surname => ({
            ...surname,
            checked: false
        }));
        setInsertSurnames(updatedSurnames);
        setInsertSelectedSurnames([]);
    };

    // Next button - Fetch voters from surname_wise_search API with validation
    const handleNextToSelectVoters = async () => {
        if (insertSelectedSurnames.length === 0) {
            alert(txt.selectAtLeastOneSurname);
            return;
        }

        // Create surname list with trailing comma
        let surnameList = insertSelectedSurnames.join(',');
        surnameList = addTrailingComma(surnameList);

        setLoadingVoters(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/surname_wise_search`, {
                app_id: appId,
                surname_list: surnameList
            });

            if (response.data.success && response.data.data.result) {
                const votersWithCheck = response.data.data.result.map(voter => ({
                    ...voter,
                    checked: true // Default all selected since these are the voters for this surname
                }));
                setSurnameWiseVoters(votersWithCheck);
                setIsInsertModalOpen(false);
                setIsSelectVotersModalOpen(true);
            } else {
                alert(txt.noVotersFound);
            }
        } catch (error) {
            console.error("Error fetching voters:", error);
            alert("Error fetching voters");
        } finally {
            setLoadingVoters(false);
        }
    };

    // Handle voter checkbox change in select voters modal
    const handleVoterCheckboxChange = (index) => {
        const updatedVoters = [...surnameWiseVoters];
        updatedVoters[index].checked = !updatedVoters[index].checked;
        setSurnameWiseVoters(updatedVoters);
    };

    // Handle voter row click in select voters modal
    const handleVoterRowClick = (index) => {
        const updatedVoters = [...surnameWiseVoters];
        updatedVoters[index].checked = !updatedVoters[index].checked;
        setSurnameWiseVoters(updatedVoters);
    };

    // Select all voters
    const handleSelectAllVoters = () => {
        const updatedVoters = surnameWiseVoters.map(voter => ({
            ...voter,
            checked: true
        }));
        setSurnameWiseVoters(updatedVoters);
    };

    // Remove all voters (uncheck all)
    const handleRemoveAllVoters = () => {
        const updatedVoters = surnameWiseVoters.map(voter => ({
            ...voter,
            checked: false
        }));
        setSurnameWiseVoters(updatedVoters);
    };

    // Final insert group with selected voters - with validation (Button Always Enabled)
    const handleFinalInsertGroup = async () => {
        // Validate group name first
        if (!insertGroupName.trim()) {
            setGroupNameError(txt.groupNameRequired);
            alert(txt.enterGroupName);
            return;
        }

        const selectedVoters = surnameWiseVoters.filter(voter => voter.checked);

        if (selectedVoters.length === 0) {
            alert(txt.selectAtLeastOneVoter);
            return;
        }

        // Get distinct surnames from selected voters
        const distinctSurnames = [...new Set(selectedVoters.map(voter => voter.eng_surname || '').filter(s => s))];

        // Create idcard list with trailing comma
        let idcardList = selectedVoters.map(voter => voter.idcard_no).join(',');
        idcardList = addTrailingComma(idcardList);

        // Create distinct surname list with trailing comma
        let surnameList = distinctSurnames.join(',');
        surnameList = addTrailingComma(surnameList);

        setInserting(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/ins_surname_group`, {
                app_id: appId,
                user_id: targetUserId,
                group_name: insertGroupName,
                seed_surname: insertGroupName,
                surname_list: surnameList,
                idcard_list: idcardList,
                modify_by: userId
            });

            if (response.data.success) {
                alert(txt.groupInsertSuccess);
                setIsSelectVotersModalOpen(false);
                fetchSurnameGroups();
            } else {
                alert(txt.groupInsertFailed);
            }
        } catch (error) {
            console.error("Error inserting group:", error);
            alert(txt.groupInsertError);
        } finally {
            setInserting(false);
        }
    };

    // Calculate selected count for edit modal
    const selectedCount = editMembers.filter(m => m.checked).length;
    const totalCount = editMembers.length;

    // Calculate selected count for insert modal
    const insertSelectedCount = insertSelectedSurnames.length;
    const insertTotalCount = insertSurnames.length;

    // Calculate selected voters count
    const selectedVotersCount = surnameWiseVoters.filter(v => v.checked).length;
    const totalVotersCount = surnameWiseVoters.length;

    return (
        <div className="surname-group-page">
            <div className="header-wrapper shadow-sm">
                <Header title={txt.pageTitle} />
            </div>

            <div className="content-container container-fluid p-3 p-md-4 mx-auto">

                {/* Stats Cards */}
                <div className="stats-container mb-4 slide-up-element" style={{ animationDelay: '0.05s' }}>
                    <div className="stat-card total-groups-card">
                        
                        <div className="stat-info">
                            <span className="stat-label">{txt.totalGroups}</span>
                            <span className="stat-value">{totalGroups}</span>
                        </div>
                    </div>
                    <div className="stat-card total-voters-card">
                        
                        <div className="stat-info">
                            <span className="stat-label">{txt.totalVoters}</span>
                            <span className="stat-value">{totalVoters.toLocaleString()}</span>
                        </div>
                    </div>
                </div>  

                {/* Search Bar & Insert Button Container */}
                <div className="filter-container mb-4 slide-up-element">
                    <div className="search-wrapper">
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.filterGroups}
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        {searchTerm && (
                            <button className="close-search-btn" onClick={() => setSearchTerm('')}>
                                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>

                    <button
                        className="btn-insert-group"
                        onClick={handleOpenInsertModal}
                    >
                        + {txt.insertGroup}
                    </button>
                </div>

                {/* Content */}
                {loading ? (
                    <div className="loader-wrapper text-center p-5">
                        <div className="spinner"></div>
                        <p className="mt-3 text-muted">{txt.loadingData}</p>
                    </div>
                ) : currentItems.length > 0 ? (
                    <>
                        <div className="row g-4 slide-up-element" style={{ animationDelay: '0.1s' }}>
                            {currentItems.map((group, index) => (
                                <div className="col-12 col-md-4 col-lg-4" key={group.group_id || index}>

                                    <div className="modern-sg-card" onClick={() => navigate('/dis_surname_group_wise_voter', {
                                        state: {
                                            user_id: targetUserId,
                                            group_id: group.group_id
                                        }
                                    })}>

                                        <div className="card-top-section">
                                            <div className="d-flex align-items-center">
                                                <div className="sg-serial-circle">
                                                    {indexOfFirstItem + index + 1}
                                                </div>
                                                <h3 className="sg-group-name">{group.surname}</h3>
                                            </div>

                                            <div className="sg-voter-pill">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}>
                                                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                                                </svg>
                                                {txt.voterCount} {group.voter_count}
                                            </div>
                                        </div>

                                        <div className="card-action-section">
                                            <button className="sg-action-btn edit-btn" onClick={(e) => { e.stopPropagation(); handleEditGroup(group.group_id, group.surname); }}>
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                                </svg>
                                                <span>{txt.edit}</span>
                                            </button>
                                            <div className="action-divider"></div>

                                            <button
                                                className="sg-action-btn delete-btn"
                                                onClick={(e) => { e.stopPropagation(); handleDeleteGroup(group.group_id); }}
                                            >
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                                    <polyline points="3 6 5 6 21 6"></polyline>
                                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                </svg>
                                                <span>{txt.delete}</span>
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        {filteredGroups.length > itemsPerPage && (
                            <div className="pagination-wrapper">
                                <div className="pagination-content">
                                    <button
                                        className="pagination-nav-btn"
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                        </svg>
                                    </button>

                                    <div className="page-numbers">
                                        {getPageNumbers().map((number, index) => (
                                            <React.Fragment key={index}>
                                                {number === '...' ? (
                                                    <span className="page-dots">...</span>
                                                ) : (
                                                    <button
                                                        className={`page-num-btn ${currentPage === number ? 'active' : ''}`}
                                                        onClick={() => paginate(number)}
                                                    >
                                                        {number}
                                                    </button>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>

                                    <button
                                        className="pagination-nav-btn"
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center text-muted p-5 bg-white rounded shadow-sm border slide-up-element">
                        <div style={{ fontSize: '40px', marginBottom: '16px' }}>📁</div>
                        <h4>{txt.noData}</h4>
                    </div>
                )}

                {/* First Modal - Select Voters for Edit */}
                {isEditModalOpen && (
                    <div className="modal-overlay">
                        <div className="edit-modal-content">
                            <div className="edit-modal-header">
                                <div className="modal-selection-info">
                                    <span className="selection-count">{txt.selectedSurnames} : {selectedCount} / {totalCount}</span>
                                    <div className="selection-actions">
                                        <button className="selection-action-btn select-all-btn" onClick={handleSelectAll}>
                                            {txt.selectAll}
                                        </button>
                                        <span className="action-separator">|</span>
                                        <button className="selection-action-btn remove-all-btn" onClick={handleRemoveAll}>
                                            {txt.removeAll}
                                        </button>
                                    </div>
                                </div>
                                <button className="modal-close-btn" onClick={() => setIsEditModalOpen(false)}>×</button>
                            </div>

                            <div className="edit-modal-body">
                                {editMembers.map((member, idx) => (
                                    <div 
                                        key={member.voter_id || idx} 
                                        className="edit-member-row clickable-row"
                                        onClick={() => handleRowClick(idx)}
                                    >
                                        <div className="member-serial">{idx + 1}</div>
                                        <div className="member-info">
                                            <div className="member-name">
                                                {member.eng_f_name} {member.eng_surname}
                                            </div>
                                            <div className="member-details">
                                                <span className="member-detail-item">ક્રમાંક  નં. : {member.slnoinpart || '-'}</span>
                                                <span className="member-detail-separator">|</span>
                                                <span className="member-detail-item">બૂથ  : {member.part_no || '-'}</span>
                                            </div>
                                            <div className="member-idcard">{member.idcard_no || '-'}</div>
                                        </div>
                                        <div className="member-checkbox" onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={member.checked}
                                                onChange={() => handleCheckboxChange(idx)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="edit-modal-footer">
                                <button
                                    className="update-group-btn"
                                    onClick={handleProceedToUpdateName}
                                >
                                    {txt.updateGroup}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Second Modal - Update Group Name */}
                {isUpdateNameModalOpen && (
                    <div className="modal-overlay">
                        <div className="update-name-modal-content">
                            <div className="update-name-modal-header">
                                <h3>{txt.updateGroupName}</h3>
                                <button className="modal-close-btn" onClick={() => setIsUpdateNameModalOpen(false)}>×</button>
                            </div>
                            <div className="update-name-modal-body">
                                <div className="form-group">
                                    <label className="form-label">{txt.groupNameLabel}</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        value={newGroupName}
                                        onChange={(e) => setNewGroupName(e.target.value)}
                                        placeholder="Enter group name"
                                    />
                                </div>
                            </div>
                            <div className="update-name-modal-footer">
                                <button
                                    className="cancel-btn"
                                    onClick={() => setIsUpdateNameModalOpen(false)}
                                >
                                    {txt.cancel}
                                </button>
                                <button
                                    className="submit-update-btn"
                                    onClick={handleFinalUpdate}
                                    disabled={updating || !newGroupName.trim()}
                                >
                                    {updating ? "Updating..." : txt.update}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Third Modal - Insert Group (Select Surnames) */}
                {isInsertModalOpen && (
                    <div className="modal-overlay">
                        <div className="insert-modal-content">
                            <div className="insert-modal-header">
                                <h3>{txt.insertGroup}</h3>
                                <button className="modal-close-btn" onClick={() => setIsInsertModalOpen(false)}>×</button>
                            </div>

                            <div className="insert-modal-body">
                                {/* Search Bar */}
                                <div className="search-wrapper-insert">
                                    <svg className="search-icon-insert" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                    <input
                                        type="text"
                                        className="search-input-insert"
                                        placeholder={txt.searchSurname}
                                        value={insertSearchTerm}
                                        onChange={(e) => setInsertSearchTerm(e.target.value)}
                                        onKeyPress={handleInsertSearchKeyPress}
                                    />
                                    <button
                                        className="search-btn-insert"
                                        onClick={handleInsertSearch}
                                        disabled={insertSearching}
                                    >
                                        {insertSearching ? txt.searching : "Search"}
                                    </button>
                                </div>

                                {/* Selection Info */}
                                {insertSurnames.length > 0 && (
                                    <div className="modal-selection-info-insert">
                                        <span className="selection-count">{txt.selectedSurnames} : {insertSelectedCount} / {insertTotalCount}</span>
                                        <div className="selection-actions">
                                            <button className="selection-action-btn select-all-btn" onClick={handleInsertSelectAll}>
                                                {txt.selectAll}
                                            </button>
                                            <span className="action-separator">|</span>
                                            <button className="selection-action-btn remove-all-btn" onClick={handleInsertRemoveAll}>
                                                {txt.removeAll}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Surnames List */}
                                <div className="insert-modal-list">
                                    {insertSearching ? (
                                        <div className="loader-wrapper-small">
                                            <div className="spinner-small"></div>
                                            <p>{txt.searching}</p>
                                        </div>
                                    ) : insertSurnames.length > 0 ? (
                                        insertSurnames.map((surname, idx) => (
                                            <div 
                                                key={idx} 
                                                className="insert-member-row clickable-row"
                                                onClick={() => handleInsertRowClick(idx)}
                                            >
                                                <div className="member-serial">{idx + 1}</div>
                                                <div className="member-info">
                                                    <div className="member-name">
                                                        {surname.eng_surname}
                                                    </div>
                                                </div>
                                                <div className="member-checkbox" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={surname.checked}
                                                        onChange={() => handleInsertCheckboxChange(idx)}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : insertSearchTerm ? (
                                        <div className="no-results-insert">
                                            <p>{txt.noSurnamesFound}</p>
                                        </div>
                                    ) : (
                                        <div className="no-results-insert">
                                            <p>🔍 {txt.searchSurname}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="insert-modal-footer">
                                <button
                                    className="cancel-btn"
                                    onClick={() => setIsInsertModalOpen(false)}
                                >
                                    {txt.cancel}
                                </button>
                                <button
                                    className="submit-next-btn"
                                    onClick={handleNextToSelectVoters}
                                    disabled={insertSelectedCount === 0}
                                >
                                    {txt.next}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Fourth Modal - Select Voters from surname_wise_search */}
                {isSelectVotersModalOpen && (
                    <div className="modal-overlay">
                        <div className="select-voters-modal-content">
                            <div className="select-voters-modal-header">
                                <h3>{txt.selectVoters}</h3>
                                <button className="modal-close-btn" onClick={() => setIsSelectVotersModalOpen(false)}>×</button>
                            </div>

                            <div className="select-voters-modal-body">
                                {/* Group Name Input with Validation */}
                                <div className="form-group mb-3">
                                    <label className="form-label">{txt.groupNameLabel}</label>
                                    <input
                                        type="text"
                                        className={`form-input ${!insertGroupName.trim() && (groupNameError || insertGroupName !== '') ? 'input-error' : ''}`}
                                        value={insertGroupName}
                                        onChange={(e) => {
                                            setInsertGroupName(e.target.value);
                                            if (e.target.value.trim()) {
                                                setGroupNameError("");
                                            }
                                        }}
                                        placeholder="Enter group name"
                                        style={{
                                            borderColor: !insertGroupName.trim() && (groupNameError || insertGroupName !== '') ? '#ef4444' : '',
                                            boxShadow: !insertGroupName.trim() && (groupNameError || insertGroupName !== '') ? '0 0 0 3px rgba(239, 68, 68, 0.1)' : ''
                                        }}
                                        onBlur={() => {
                                            if (!insertGroupName.trim()) {
                                                setGroupNameError(txt.groupNameRequired);
                                            }
                                        }}
                                        onFocus={() => {
                                            if (groupNameError) {
                                                setGroupNameError("");
                                            }
                                        }}
                                    />
                                    {!insertGroupName.trim() && groupNameError && (
                                        <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
                                            ⚠️ {txt.groupNameRequired}
                                        </div>
                                    )}
                                </div>

                                {/* Selection Info with Validation */}
                                <div className="modal-selection-info-insert">
                                    <span className="selection-count" style={{
                                        backgroundColor: selectedVotersCount === 0 && totalVotersCount > 0 ? '#fef2f2' : '',
                                        color: selectedVotersCount === 0 && totalVotersCount > 0 ? '#dc2626' : ''
                                    }}>
                                        {txt.selectedSurnames} : {selectedVotersCount} / {totalVotersCount}
                                    </span>
                                    <div className="selection-actions">
                                        <button className="selection-action-btn select-all-btn" onClick={handleSelectAllVoters}>
                                            {txt.selectAll}
                                        </button>
                                        <span className="action-separator">|</span>
                                        <button className="selection-action-btn remove-all-btn" onClick={handleRemoveAllVoters}>
                                            {txt.removeAll}
                                        </button>
                                    </div>
                                </div>
                                {selectedVotersCount === 0 && totalVotersCount > 0 && (
                                    <div style={{ color: '#dc2626', fontSize: '12px', marginBottom: '12px', textAlign: 'center' }}>
                                        ⚠️ {txt.selectAtLeastOneVoter}
                                    </div>
                                )}

                                {/* Voters List */}
                                <div className="select-voters-list">
                                    {loadingVoters ? (
                                        <div className="loader-wrapper-small">
                                            <div className="spinner-small"></div>
                                            <p>{txt.loadingVoters}</p>
                                        </div>
                                    ) : surnameWiseVoters.length > 0 ? (
                                        surnameWiseVoters.map((voter, idx) => (
                                            <div 
                                                key={voter.voter_id || idx} 
                                                className="select-voter-row clickable-row"
                                                onClick={() => handleVoterRowClick(idx)}
                                            >
                                                <div className="member-serial">{idx + 1}</div>
                                                <div className="member-info">
                                                    <div className="member-name">
                                                        {voter.eng_f_name} {voter.eng_surname}
                                                    </div>
                                                    <div className="member-details">
                                                        <span className="member-detail-item">ક્રમાંક  નં. : {voter.slnoinpart || '-'}</span>
                                                        <span className="member-detail-separator">|</span>
                                                        <span className="member-detail-item">બૂથ  : {voter.part_no || '-'}</span>
                                                    </div>
                                                    <div className="member-idcard">{voter.idcard_no || '-'}</div>
                                                </div>
                                                <div className="member-checkbox" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={voter.checked}
                                                        onChange={() => handleVoterCheckboxChange(idx)}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="no-results-insert">
                                            <p>{txt.noVotersFound}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="select-voters-modal-footer">
                                <button
                                    className="cancel-btn"
                                    onClick={() => setIsSelectVotersModalOpen(false)}
                                >
                                    {txt.cancel}
                                </button>
                                <button
                                    className="submit-insert-btn"
                                    onClick={handleFinalInsertGroup}
                                    // Button is always enabled - no disabled condition
                                >
                                    {inserting ? "Inserting..." : txt.insert}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <style jsx>{`
                .surname-group-page {
                    width: 100%;
                    min-height: 100vh;
                    background: #eef2f6;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    padding-bottom: 40px;
                }
                .header-wrapper {
                    background: white;
                    padding: 0 24px;
                    position: sticky;
                    top: 0;
                    z-index: 50;
                }

                /* Stats Cards */
                .stats-container {
                    display: flex;
                    gap: 16px;
                    flex-wrap: wrap;
                }
                .stat-card {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    background: white;
                    padding: 20px 24px;
                    border-radius: 16px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e2e8f0;
                    transition: all 0.2s ease;
                }
                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
                }
                .total-groups-card { border-left: 4px solid #3b82f6; }
                .total-voters-card { border-left: 4px solid #10b981; }
                .stat-icon { font-size: 36px; }
                .stat-info { display: flex; flex-direction: column; }
                .stat-label { font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
                .stat-value { font-size: 32px; font-weight: 800; color: #0f172a; line-height: 1.2; }
                .total-groups-card .stat-value { color: #3b82f6; }
                .total-voters-card .stat-value { color: #10b981; }

                /* Search Bar & Filter Container */
                .filter-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 12px;
                }
                .search-wrapper { position: relative; width: 100%; }
                .search-icon { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 20px; height: 20px; }
                .search-input { width: 100%; padding: 14px 40px 14px 46px; border: 1px solid #cbd5e1; border-radius: 12px; font-size: 15px; color: #1e293b; background-color: #ffffff; outline: none; transition: all 0.2s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
                .search-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
                .close-search-btn { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: #f1f5f9; border: none; border-radius: 50%; padding: 4px; color: #64748b; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
                .close-search-btn:hover { background: #e2e8f0; color: #1e293b; }

                .btn-insert-group {
                    background-color: #3b82f6;
                    color: white;
                    padding: 12px 20px;
                    border: none;
                    border-radius: 10px;
                    font-weight: 600;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: background 0.2s;
                }
                .btn-insert-group:hover {
                    background-color: #2563eb;
                }

                /* Modern Card CSS */
                .modern-sg-card {
                    background: #ffffff;
                    border-radius: 16px;
                    border: 1px solid #cbd5e1;
                    overflow: hidden;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    cursor: pointer;
                }
                .modern-sg-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 16px -4px rgba(0,0,0,0.1);
                    border-color: #94a3b8;
                }

                .card-top-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px 24px;
                    background: white;
                }
                .sg-serial-circle {
                    width: 42px;
                    height: 42px;
                    background-color: #3b426e;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.1rem;
                    font-weight: 800;
                    margin-right: 16px;
                    flex-shrink: 0;
                }
                .sg-group-name {
                    margin: 0;
                    font-size: 1.2rem;
                    font-weight: 800;
                    color: #1e293b;
                    word-break: break-word;
                }
                .sg-voter-pill {
                    background-color: #eef2ff;
                    color: #1e3a8a;
                    font-weight: 700;
                    font-size: 13px;
                    padding: 6px 14px;
                    border-radius: 20px;
                    border: 1px solid #c7d2fe;
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                }

                .card-action-section {
                    display: flex;
                    align-items: center;
                    border-top: 1px solid #e2e8f0;
                    background: #ffffff;
                }
                .sg-action-btn {
                    flex: 1;
                    background: transparent;
                    border: none;
                    padding: 14px 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    font-size: 15px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: background 0.2s ease;
                }
                .sg-action-btn:hover {
                    background: #f8fafc;
                }
                .edit-btn { color: #3b426e; }
                .delete-btn { color: #e11d48; }
                .action-divider {
                    width: 1px;
                    height: 30px;
                    background-color: #e2e8f0;
                }

                /* Clickable Row Styles */
                .clickable-row {
                    cursor: pointer;
                    transition: background-color 0.2s ease;
                }
                .clickable-row:hover {
                    background-color: #f1f5f9;
                }

                /* Loader */
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 40vh; width: 100%; }
                .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

                /* Pagination */
                .pagination-wrapper { display: flex; justify-content: center; padding: 30px 0 10px 0; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); }
                .pagination-nav-btn { width: 32px; height: 32px; border-radius: 50%; border: none; background: transparent; color: #1e3a8a; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background-color: #eff6ff; }
                .pagination-nav-btn:disabled { color: #cbd5e1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 4px; align-items: center; }
                .page-num-btn { min-width: 32px; height: 32px; padding: 0 6px; border-radius: 50%; border: 1px solid transparent; background: transparent; color: #475569; font-weight: 600; font-size: 13px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn:hover { color: #1e3a8a; background-color: #f8fafc; }
                .page-num-btn.active { background-color: #1e3a8a; color: white; box-shadow: 0 2px 4px rgba(30, 58, 138, 0.3); }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                /* Animation */
                .slide-up-element { animation: slideUp 0.4s ease forwards; opacity: 0; }
                @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

                /* First Modal - Edit Voters */
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }
                .edit-modal-content {
                    background: white;
                    width: 90%;
                    max-width: 500px;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.3);
                    animation: modalSlideIn 0.3s ease;
                }
                @keyframes modalSlideIn {
                    from {
                        opacity: 0;
                        transform: scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                .edit-modal-header {
                    padding: 16px 20px;
                    background: #f8fafc;
                    border-bottom: 1px solid #e2e8f0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .modal-selection-info {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }
                .selection-count {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1e293b;
                    background: #e2e8f0;
                    padding: 4px 12px;
                    border-radius: 20px;
                }
                .selection-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .selection-action-btn {
                    background: none;
                    border: none;
                    font-size: 13px;
                    font-weight: 600;
                    cursor: pointer;
                    padding: 4px 8px;
                    border-radius: 6px;
                    transition: background 0.2s;
                }
                .select-all-btn { color: #3b82f6; }
                .select-all-btn:hover { background: #eff6ff; }
                .remove-all-btn { color: #ef4444; }
                .remove-all-btn:hover { background: #fef2f2; }
                .action-separator { color: #cbd5e1; font-size: 14px; }
                .modal-close-btn {
                    background: #f1f5f9;
                    border: none;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    font-size: 24px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    transition: all 0.2s;
                }
                .modal-close-btn:hover { background: #e2e8f0; color: #1e293b; }
                .edit-modal-body { max-height: 450px; overflow-y: auto; padding: 8px 0; }
                .edit-member-row {
                    display: flex;
                    align-items: center;
                    padding: 14px 20px;
                    border-bottom: 1px solid #f1f5f9;
                    transition: background 0.2s;
                }
                .member-serial { width: 32px; font-size: 14px; font-weight: 700; color: #64748b; flex-shrink: 0; }
                .member-info { flex: 1; padding-left: 8px; }
                .member-name { font-size: 15px; font-weight: 700; color: #1e293b; margin-bottom: 4px; }
                .member-details { font-size: 11px; color: #64748b; display: flex; align-items: center; gap: 6px; margin-bottom: 3px; flex-wrap: wrap; }
                .member-detail-separator { color: #cbd5e1; }
                .member-idcard { font-size: 11px; color: #3b82f6; font-weight: 500; font-family: monospace; }
                .member-checkbox { flex-shrink: 0; margin-left: 12px; }
                .member-checkbox input[type="checkbox"] { width: 20px; height: 20px; cursor: pointer; accent-color: #3b82f6; }
                .edit-modal-footer { padding: 16px 20px; border-top: 1px solid #e2e8f0; background: #f8fafc; }
                .update-group-btn { width: 100%; background: #3b82f6; color: white; border: none; padding: 12px; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; transition: background 0.2s; }
                .update-group-btn:hover { background: #2563eb; }

                /* Second Modal - Update Group Name */
                .update-name-modal-content { background: white; width: 90%; max-width: 400px; border-radius: 20px; overflow: hidden; box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.3); animation: modalSlideIn 0.3s ease; }
                .update-name-modal-header { padding: 20px 24px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; }
                .update-name-modal-header h3 { margin: 0; font-size: 18px; font-weight: 700; color: #1e293b; }
                .update-name-modal-body { padding: 24px; }
                .form-group { margin-bottom: 0; }
                .form-label { display: block; font-size: 14px; font-weight: 600; color: #1e293b; margin-bottom: 8px; }
                .form-input { width: 100%; padding: 12px 16px; border: 1px solid #cbd5e1; border-radius: 12px; font-size: 15px; color: #1e293b; outline: none; transition: all 0.2s ease; }
                .form-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
                .update-name-modal-footer { padding: 16px 24px; border-top: 1px solid #e2e8f0; background: #f8fafc; display: flex; gap: 12px; }
                .cancel-btn { flex: 1; background: #f1f5f9; color: #64748b; border: none; padding: 12px; border-radius: 12px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
                .cancel-btn:hover { background: #e2e8f0; }
                .submit-update-btn { flex: 1; background: #3b82f6; color: white; border: none; padding: 12px; border-radius: 12px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
                .submit-update-btn:hover { background: #2563eb; }
                .submit-update-btn:disabled { background: #94a3b8; cursor: not-allowed; }

                /* Third Modal - Insert Group (Select Surnames) */
                .insert-modal-content { background: white; width: 90%; max-width: 500px; border-radius: 20px; overflow: hidden; box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.3); animation: modalSlideIn 0.3s ease; }
                .insert-modal-header { padding: 20px 24px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; }
                .insert-modal-header h3 { margin: 0; font-size: 18px; font-weight: 700; color: #1e293b; }
                .insert-modal-body { padding: 20px; max-height: 500px; overflow-y: auto; }
                .search-wrapper-insert { position: relative; display: flex; gap: 8px; margin-bottom: 16px; }
                .search-icon-insert { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 18px; height: 18px; }
                .search-input-insert { flex: 1; padding: 10px 12px 10px 38px; border: 1px solid #cbd5e1; border-radius: 10px; font-size: 14px; color: #1e293b; outline: none; transition: all 0.2s ease; }
                .search-input-insert:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
                .search-btn-insert { background: #3b82f6; color: white; border: none; padding: 10px 16px; border-radius: 10px; font-size: 13px; font-weight: 600; cursor: pointer; transition: background 0.2s; white-space: nowrap; }
                .search-btn-insert:hover { background: #2563eb; }
                .search-btn-insert:disabled { background: #94a3b8; cursor: not-allowed; }
                .modal-selection-info-insert { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding: 8px 0; border-top: 1px solid #e2e8f0; border-bottom: 1px solid #e2e8f0; }
                .insert-modal-list { max-height: 300px; overflow-y: auto; }
                .insert-member-row { display: flex; align-items: center; padding: 12px 8px; border-bottom: 1px solid #f1f5f9; transition: background 0.2s; }
                .loader-wrapper-small { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px; }
                .spinner-small { width: 30px; height: 30px; border: 3px solid #E5E7EB; border-top: 3px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 10px; }
                .no-results-insert { text-align: center; padding: 40px; color: #94a3b8; }
                .insert-modal-footer { padding: 16px 24px; border-top: 1px solid #e2e8f0; background: #f8fafc; display: flex; gap: 12px; }
                .submit-next-btn { flex: 1; background: #3b82f6; color: white; border: none; padding: 12px; border-radius: 12px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
                .submit-next-btn:hover { background: #2563eb; }
                .submit-next-btn:disabled { background: #94a3b8; cursor: not-allowed; }

                /* Fourth Modal - Select Voters */
                .select-voters-modal-content { background: white; width: 90%; max-width: 550px; border-radius: 20px; overflow: hidden; box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.3); animation: modalSlideIn 0.3s ease; }
                .select-voters-modal-header { padding: 20px 24px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; }
                .select-voters-modal-header h3 { margin: 0; font-size: 18px; font-weight: 700; color: #1e293b; }
                .select-voters-modal-body { padding: 20px; max-height: 550px; overflow-y: auto; }
                .select-voters-list { max-height: 350px; overflow-y: auto; }
                .select-voter-row { display: flex; align-items: center; padding: 12px 8px; border-bottom: 1px solid #f1f5f9; transition: background 0.2s; }
                .select-voter-row:hover { background: #fafcff; }
                .select-voters-modal-footer { padding: 16px 24px; border-top: 1px solid #e2e8f0; background: #f8fafc; display: flex; gap: 12px; }
                .submit-insert-btn { 
                    flex: 1; 
                    background: #3b82f6; 
                    color: white; 
                    border: none; 
                    padding: 12px; 
                    border-radius: 12px; 
                    font-size: 14px; 
                    font-weight: 600; 
                    cursor: pointer; 
                    transition: background 0.2s; 
                }
                .submit-insert-btn:hover { 
                    background: #2563eb; 
                }
                .mb-3 { margin-bottom: 16px; }
                
                /* Input Error Style */
                .input-error { border-color: #ef4444 !important; }
                .input-error:focus { border-color: #ef4444 !important; box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important; }

                /* --- MOBILE RESPONSIVE FIX --- */
                @media (max-width: 768px) {
                    /* Stats Cards in One Row */
                    .stats-container { 
                        flex-direction: row; /* Hamesha row ma rahese */
                        gap: 12px; 
                    }
                    .stat-card { 
                        padding: 12px; 
                        gap: 12px; 
                    }
                    .stat-value { font-size: 22px; }
                    .stat-icon { font-size: 26px; }
                    .stat-label { font-size: 10px; }
                }

                @media (max-width: 640px) {
                    /* Search and Insert Button in One Row */
                    .filter-container {
                        flex-direction: row; /* Hamesha row ma rahese */
                        align-items: center;
                        gap: 8px; /* Gap ochhu karyu */
                    }
                    .search-wrapper { 
                        max-width: none; 
                        flex: 1; /* Pura space ma fill thashe */
                    }
                    .btn-insert-group {
                        width: auto; /* Width auto kari */
                        padding: 10px 14px; 
                        font-size: 12px; /* Text nana karya */
                    }
                    .search-input {
                        padding: 10px 30px 10px 40px; 
                        font-size: 13px;
                    }

                    .card-top-section { padding: 16px; }
                    .sg-serial-circle { width: 36px; height: 36px; font-size: 1rem; margin-right: 12px; }
                    .sg-group-name { font-size: 1.05rem; }
                    .sg-voter-pill { font-size: 11px; padding: 4px 10px; }
                    .sg-action-btn { padding: 12px 0; font-size: 14px; }
                    .edit-modal-content { width: 95%; max-width: 95%; }
                    .member-serial { width: 28px; font-size: 12px; }
                    .member-name { font-size: 13px; }
                    .member-details { font-size: 10px; }
                    .update-name-modal-content { width: 95%; }
                    .insert-modal-content { width: 95%; }
                    .select-voters-modal-content { width: 95%; }
                    .search-wrapper-insert { flex-direction: column; }
                    .search-btn-insert { width: 100%; }
                }
            `}</style>
        </div>
    );
};

export default SurnameGroup;